module.exports = __webpack_public_path__ + "img/none.5adac6a0.png";